import { jsxs, jsx } from 'react/jsx-runtime';
import { Typography } from '../Typography/Typography.js';

const TosAndPp = ({ privacyPolicyUrl, termsOfServiceUrl, mode, }) => {
    if (!privacyPolicyUrl || !termsOfServiceUrl) {
        return null;
    }
    return (jsxs(Typography, Object.assign({ variant: 'body_mini', weight: 'regular', className: 'tos-and-pp__text' }, { children: ["By ", mode, ", you agree to our\u00A0", jsx("a", Object.assign({ className: 'tos-and-pp__link', href: termsOfServiceUrl, target: '_blank', rel: 'noreferrer' }, { children: "Terms of Services" })), "\u00A0&\u00A0", jsx("a", Object.assign({ className: 'tos-and-pp__link', href: privacyPolicyUrl, target: '_blank', rel: 'noreferrer' }, { children: "Privacy Policy" })), "."] })));
};

export { TosAndPp };
